import axios from "axios";

const API_URL =
  import.meta.env.VITE_API_BASE_URL || "https://thalvora-exports.onrender.com";

export interface Category {
  id: string;
  name: string;
  slug: string;
  description: string;
  imageUrl: string;
  productCount: number;
  displayOrder?: number;
}

class CategoryService {
  async getAllCategories(): Promise<Category[]> {
    const res = await axios.get(
      `${API_URL}/categories/public/with-count`
    );

    // ✅ handle both formats: [] OR { data: [] }
    return res.data?.data || res.data || [];
  }
}

export const categoryService = new CategoryService();